import React, { useState, useEffect } from "react";
import NotVerifiedView from "../views/loginStack/NotVerifiedView/NotVerifiedView";
import { useSelector } from "react-redux";
import AddModal from "../utilComponents/AddModal.js";

const WithVerifyMailModal = (Component) => {
  const NewComponent = (args) => {
    const loginState = useSelector((state) => state.loginState);
    const isMailVerified = loginState.login.userInfo.isMailVerified;

    return (
      <>
        <AddModal
          Component={({ openModal }) => (
            <>
              <Component {...args} openVerifyMailModal={openModal} />
            </>
          )}
          ModalContent={({ closeModal, isModalFullyOpened, setError }) => {

            return (
              <NotVerifiedView
                showHomePage={false}
                EMAIL
                autoRelogin={false}
                isInModal
                modalFullyOpened={isModalFullyOpened}
                setModalError={setError}
              />
            );
          }}
          modalCondition={!isMailVerified}
        />
      </>
    );
  };
  return NewComponent;
};

export default WithVerifyMailModal;
